/** True when a server `setting` / runtime flag value is enabled. */
export function isTruthySetting(value: unknown): boolean {
	return value === '1' || value === 1 || value === true || value === 'true';
}

/** Route Builder v2 master switch (`config_rb2_enabled` from server settings). */
export function isRb2FeatureEnabled(source: { config_rb2_enabled?: unknown } | null | undefined): boolean {
	return isTruthySetting(source?.config_rb2_enabled);
}

export function configFlagEnabled(
	config: Record<string, unknown> | null | undefined,
	key: string | undefined
): boolean {
	if (!key) {
		return true;
	}
	return isTruthySetting(config?.[key]);
}
